module.exports = __webpack_public_path__ + "img/9788958102441.7fbb85e0.jpg";